import ErrorIcon from "./Icons/ErrorIcon";

const Error = ({ error }) => {
  return (
    <div className="bg-red-50 border-l-4 border-red-400 p-4 rounded-lg shadow-sm">
      <div className="flex items-center">
        <ErrorIcon />
        <p className="text-red-700 mt-1">
          {error}
        </p>
      </div>
    </div>
  );
}

export default Error